module.exports = __webpack_public_path__ + "img/discount11.983e6938.png";